// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"s6-z","dimensionLabel":"t6-z","styleChooserControlWrapper":"u6-z","styleChooserControl":"v6-z","disabled":"w6-z","giftCard":"x6-z","styleChooserText":"y6-z"};